<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="productServiceForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{productId ? 'Edit' : 'Add'}}
            </h1>

            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2 relative">
                <!-- Name -->
                <div class="space-y-1">
                    <label class="subheading after:content-['*'] after:text-red-600">
                        Name
                    </label>
                    <input formControlName="Name" type="text" />
                    <div *ngIf="submitted && productServiceForm.get('Name')?.errors">
                        <p *ngIf="productServiceForm.get('Name')?.errors?.required"
                            class="error text-red-600 text-xs mt-1">
                            Name is required
                        </p>
                    </div>
                </div>

                <!-- Quantity on Hand -->
                <div class="space-y-1">
                    <label class="subheading">
                        SKU
                    </label>
                    <input formControlName="Sku" type="text" />
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Description
                    </label>
                    <textarea formControlName="Description" id=""></textarea>
                </div>

                <!-- Quantity on Hand -->
                <div class="space-y-1">
                    <label class="subheading">
                        Quantity on Hand <span class="text-red-600">*</span>
                    </label>
                    <input formControlName="QtyOnHand" type="number" />
                </div>

                <!-- Unit Price -->
                <div class="space-y-1">
                    <label class="subheading">
                        Unit Price <span class="text-red-600">*</span>
                    </label>
                    <input formControlName="UnitPrice" type="text" />
                </div>

                <!-- Type -->
                <div class="space-y-1">
                    <label class="subheading after:content-['*'] after:text-red-600">
                        Type
                    </label>
                    <ng-select [items]="['Service', 'NonInventory']" bindLabel="" bindValue="" formControlName="Type"
                        placeholder="Select Type">
                    </ng-select>

                    <div *ngIf="submitted && form['Type'].errors">
                        <p *ngIf="form['Type'].errors?.['required']" class="error text-red-600 text-xs mt-1">
                            Type is required
                        </p>
                    </div>


                </div>
                <!-- Income Account -->
                <div formGroupName="IncomeAccountRef" (change)="onIncomeAccountRefChange($event)" class="space-y-1">
                    <label class="subheading after:content-['*'] after:text-red-600">Income Account</label>
                    <div>
                        <select formControlName="value" id="Id" (change)="onIncomeAccountRefChange($event)">
                            <option value="" disabled>Select Account</option>

                            <option *ngFor="let account of accountDetail" [value]="account.Id">
                                {{ account.Name | titlecase }}
                            </option>
                        </select>
                        <div *ngIf="submitted && incomeAccountRef.value.errors">
                            <p *ngIf="incomeAccountRef.value.errors?.required" class="error text-red-600 text-xs mt-1">
                                Value is required
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <h1 class="heading mt-4">
                Reference
            </h1>
            <hr class="my-2 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2" formGroupName="reference">
                <!-- ---reference -->
                <!-- Level of Service -->
                <div class="space-y-1">
                    <label class="subheading">Level of Service </label>
                    <div>
                        <select [(ngModel)]="selectedLos" 
                            (change)="onLosChange()" [ngModelOptions]="{ standalone: true }">
                            <option value="">Select Level of Service</option>
                            <option *ngFor="let los of levelOfServices" [value]="los.id">
                                {{ (los.title) | uppercase }}
                            </option>
                        </select>
                        <div *ngIf="submitted && productServiceForm.get('reference')?.errors?.['atLeastOneRequired']"
                            class="text-red-600 text-xs mt-1">
                            Please select at least one: Level of Service, Space Type, or Addon.
                        </div>
                    </div>
                </div>

                <!-- Space Type -->
                <div class="space-y-1">
                    <label class="subheading">Space Type</label>
                    <div>
                        <select [(ngModel)]="selectedSpacetype" 
                            (change)="onSpaceTypeChange()" [ngModelOptions]="{ standalone: true }">
                            <option value="">Select Space Type</option>
                            <option *ngFor="let spacetype of spacetypes" [value]="spacetype.id">
                                {{ (spacetype.title) | uppercase }}
                            </option>
                        </select>
                        <div *ngIf="submitted && productServiceForm.get('reference')?.errors?.['atLeastOneRequired']"
                            class="text-red-600 text-xs mt-1">
                            Please select at least one: Level of Service, Space Type, or Addon.
                        </div>
                    </div>
                </div>

                <!-- Addon -->
                <div class="space-y-1">
                    <label class="subheading">Addon</label>
                    <div>
                        <select [(ngModel)]="selectedAddon"
                            (change)="onAddonChange()" [ngModelOptions]="{ standalone: true }">
                            <option value="">Select Addon</option>
                            <option *ngFor="let addon of addons" [value]="addon.id">
                                {{ (addon.title ) | titlecase }}
                            </option>
                        </select>
                        <div *ngIf="submitted && productServiceForm.get('reference')?.errors?.['atLeastOneRequired']"
                            class="text-red-600 text-xs mt-1">
                            Please select at least one: Level of Service, Space Type, or Addon.
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" name="name" id="name" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        ID
                    </label>
                    <div>
                        <div>
                            <input formControlName="id" name="id" id="id" type="text" />
                        </div>
                    </div>
                </div>
            
                <div class="space-y-1">
                    <label class="subheading">
                        Type
                    </label>
                    <div>
                        <div>
                            <input formControlName="type" name="type" id="type" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading after:content-['*'] after:text-red-600">
                        Priority
                    </label>
                    <div>
                        <div>
                            <input formControlName="priority" name="priority" id="priority" type="number" />
                        </div>
                    </div>
                </div>

                 <!-- funding source -->

                <div class="space-y-1">
                    <label for="fundingSource" class="subheading">Funding Source</label>
                    <div class="mt-1">
                        <ng-select id="fundingSource" formControlName="fundingSource" [clearable]="false" class="">
                            <ng-option value=""> Select Funding Source</ng-option>
                            <ng-option *ngFor="let fundingSource of fundingSources" value="{{ fundingSource.id }}">{{fundingSource.title |
                                titlecase}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <!-- <div *ngIf="productServiceForm.get('fundingSource')?.errors && submitted">
                        <div *ngIf="productServiceForm.get('fundingSource')?.errors?.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Funding Source is required
                            </p>
                        </div>
                    </div> -->
                </div>


                <div class="space-y-1">
                    <div class="inline-flex">
                         <div class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                           <label class="subheading">Per Mile</label>
                    <div class="flex">
                        <label
                            class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <input type="checkbox" formControlName="isPerMile" class="peer sr-only" (change)="togglePerMile($event)"
                                aria-checked="productServiceForm.get('reference.isPerMile')?.value" />
                            <span
                                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                <span *ngIf="!productServiceForm.get('reference.isPerMile')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                    aria-hidden="true">
                                    <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span *ngIf="productServiceForm.get('reference.isPerMile')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                        stroke="currentColor" class="h-3 w-3 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                    </svg>
                                </span>
                            </span>
                        </label>
                    </div>
                 </div>
                    </div>
                
                </div>
                
                
                </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{productId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>